<form [formGroup]="inviteExternalBeneForm" #inviteBene="ngForm" (ngSubmit)="inviteExternalBeneFormSub()">
  <div class="container p-0">
    <div class="form-row">
      <div class="form-group col-md-4">
        <div class="p-field">
          <label for="firstName" class="required">First Name</label>
          <input id="firstName" type="text" pInputText formControlName="firstName"
            [ngClass]="{ 'im-input-error': (f.firstName.touched || isSubmitted) && f.firstName.errors  }"  (change)="generateUniqueUsername(popover)"/>
        </div>
      </div>
      <div class="form-group col-md-4">
        <div class="p-field">
          <label for="lastName" class="required">Last Name</label>
          <input id="lastName" type="text" pInputText formControlName="lastName"
            [ngClass]="{ 'im-input-error': (f.lastName.touched || isSubmitted) && f.lastName.errors  }" (change)="generateUniqueUsername(popover)" />
        </div>
      </div>
      <div class="form-group col-md-4">
        <div class="p-field">
          <label for="middlename">Middle Name</label>
          <input id="middlename" type="text" pInputText formControlName="middleName" />
        </div>
      </div>
      <div class="form-group col-md-4">
        <div class="p-field">
          <label for="communicationEmailId" class="required">Communication Email Id</label>
          <input id="communicationEmailId" type="text" pInputText formControlName="communicationEmailId"
            [ngClass]="{ 'im-input-error': (f.communicationEmailId.touched || isSubmitted) && f.communicationEmailId.errors  }" />
        </div>
      </div>

      <!-- <div class="form-group col-md-4" *ngIf="userType==='Petitioner'">
        <div class="p-field">
          <label for="userId" class="required">User ID</label>
          <input id="userId"  type="text" pInputText placeholder="Employee Code" formControlName="userId" /> 
        </div>
      </div>  -->

       
        <div class="form-group col-md-6" *ngIf="userType==='Petitioner'">
        
          <label class="required">User Name / Id </label>
          <input type="text" class="form-control" formControlName="userId" placeholder="User Name / Id" (focus)="autoGeneratedId=false;popover.close();" (keyup)="onChangeUserId()" ngbPopover="Recommended" [autoClose]="false" triggers="manual" #popover="ngbPopover"       placement="top-right" popoverClass="username-recommended-popover"/>
          <small *ngIf="inviteExternalBeneForm.get('userId').touched && inviteExternalBeneForm.get('userId').errors" class="p-error">
            <span *ngIf="inviteExternalBeneForm.get('userId').errors['required']">Required</span>
          </small>
          <app-userId-validation *ngIf="inviteExternalBeneForm.controls['userId'].dirty" [userId]="inviteExternalBeneForm.value.userId" [checkUserIdAvailability]="true"
            (isValid)="setUserIdValidity($event)" [isSystemGenerated]="autoGeneratedId">
          </app-userId-validation>
          <!-- <lib-user-id-validation-library *ngIf="inviteExternalBeneForm.controls['userId'].dirty"
            [userId]="inviteExternalBeneForm.value.userId" [checkUserIdAvailability]="true" (isValid)="setUserIdValidity($event)">
          </lib-user-id-validation-library> -->
        </div>
       

    </div>
    <div class="form-row">
      <button type="submit" class="im-btn im-btn-primary im-btn-md" [disabled]="inviteExternalBeneForm.invalid">
        Send Invite
      </button>
    </div>
  </div>
</form>
